export default __webpack_public_path__ + "static/media/reunion232.2c6ee45e.jpg";